import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import CategoryGrid from './components/CategoryGrid';
import HotFinds from './components/HotFinds';
import ArticleCTA from './components/ArticleCTA';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import { SITE_URL } from '@/constants';

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "KakobuyFinds",
  "url": SITE_URL,
  "description": "Kakobuy Spreadsheet – najlepsza polska baza produktów Kakobuy. Odkryj setki sprawdzonych linków do sneakersów, streetwearu, elektroniki i akcesoriów. Regularnie aktualizowana baza z porównaniami cen i ocenami jakości.",
  "inLanguage": "pl-PL",
  "potentialAction": {
    "@type": "SearchAction",
    "target": SITE_URL + "/?s={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <Navbar />
      <main>
        <Hero />
        <AboutSection />
        <CategoryGrid />
        <HotFinds />
        <ArticleCTA />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}